export default __webpack_public_path__ + "static/media/1.757d5503.png";